/* eslint-disable import/order */
import { MenuIdFilters } from '@jira/navigation-apps__constants/src/MenuIdFilters.tsx';
import { filtersDirectoryResource } from '@jira/router-resources__directories-filters/src/filtersDirectoryResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { filtersDirectoryRedirectRoute } from '@jira/router-routes__directories-routes/src/filtersDirectoryRedirectRoute.tsx';
import { FiltersDirectorySkeleton } from '@jira/platform__skeletons/src/ui/directories/FiltersDirectorySkeleton.tsx';
import type { Route } from '@atlassian/react-resource-router';
import {
	FiltersDirectoryComponent,
	FiltersDirectoryRedirect,
	LazyFiltersDirectory,
} from './ui/filters/index.tsx';

export const filtersDirectoryRedirectRouteEntry: Route = createEntry(
	filtersDirectoryRedirectRoute,

	() => ({
		group: 'directories',
		resources: [...getNavigationResources(), filtersDirectoryResource],
		// eslint-disable-next-line no-restricted-syntax
		component: !__SERVER__ ? FiltersDirectoryRedirect : FiltersDirectoryComponent,
		skeleton: FiltersDirectorySkeleton,
		layout: globalLayout,

		navigation: {
			menuId: MenuIdFilters,
		},

		forPaint: [LazyAtlassianNavigation, LazyFiltersDirectory],
		isRedirect: true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
